<div class="main">
    <div class="frm" dir="rtl">

        <h2 style="text-align: center;">{{had}}</h2>

        <form #f="ngForm" (ngSubmit)="submit()">
            <div class="row">
                <div class="btnSave">
                    <button class="btn btn-primary" [disabled]="f.invalid || isRequesting">Save</button>
                </div>
            </div>

            <div class="row frm2" style="background-color:#f4f4f4">
                <div class="row">

                    <div class="col-lg-6 pull-right">
                        <div class="row">

                            <div class="col-lg-6 pull-right">
                                <div class="form-group">
                                    <label for="category" style="font-weight:bold">Category</label>
                                    <select required id="category" name="category" class="form-control" (change)="onCategoryChange($event)" [(ngModel)]="mkm.categoryId">
                                        <option *ngFor="let c of categorys" [value]="c.id">{{c.name}}</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label for="state" style="font-weight:bold">State</label>
                                    <select required id="state" name="state" class="form-control" (change)="onStateChange()" [(ngModel)]="mkm.city.stateId">
                                        <option *ngFor="let s of states" [value]="s.id">{{s.stateY}}</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label for="city" style="font-weight:bold">City</label>
                                    <select required id="city" name="city" class="form-control" [(ngModel)]="mkm.cityId">
                                        <option *ngFor="let c of citys" [value]="c.id">{{c.cityY}}</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label for="mkmTitle" style="font-weight:bold">נאמען</label>
                                    <input id="mkmTitle" name="mkmTitle" class="form-control" [(ngModel)]="mkm.mkmTitle" />
                                </div>
                            </div>

                            <div class="col-lg-6 pull-right">
                                <div dir="ltr" class="form-group">
                                    <label for="streetNumber" style="font-weight:bold">Street Number</label>
                                    <input id="streetNumber" name="streetNumber" class="form-control" [(ngModel)]="mkm.streetNumber" />
                                </div>
                                <div dir="ltr" class="form-group">
                                    <label for="streetName" style="font-weight:bold">Street Name</label>
                                    <input id="streetName" name="streetName" class="form-control" [(ngModel)]="mkm.streetName" />
                                </div>
                                <div dir="ltr" class="form-group">
                                    <label for="areaLevel" style="font-weight:bold">Area Level</label>
                                    <input id="areaLevel" name="areaLevel" class="form-control" [(ngModel)]="mkm.areaLevel" />
                                </div>
                                <div dir="ltr" class="form-group">
                                    <label for="poi" style="font-weight:bold; color:blue; cursor:pointer" (click)="onPoiClick()">poi</label>
                                    <input required id="poi" name="poi" class="form-control" [(ngModel)]="mkm.poi" />
                                </div>
                                <div dir="ltr" class="form-group">
                                    <label for="cohanPlace" style="font-weight:bold; color:blue; cursor:pointer" (click)="onCohenClick()">Cohen Place</label>
                                    <input required id="cohanPlace" name="cohanPlace" class="form-control" [(ngModel)]="mkm.cohanPlace" />
                                </div>
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-lg-6 pull-right">
                                <div dir="ltr" class="form-group">
                                    <label for="sInfo" style="font-weight:bold">Contact Information</label>
                                    <textarea id="sInfo" name="sInfo" cols="25" rows="5" class="form-control" [(ngModel)]="mkm.sInfo"></textarea>
                                </div>
                            </div>
                            <div class="col-lg-6 pull-right">
                                <div dir="ltr" class="form-group">
                                    <label for="info" style="font-weight:bold">Information</label>
                                    <textarea id="info" name="info" cols="25" rows="5" class="form-control" [(ngModel)]="mkm.info"></textarea>
                                </div>
                            </div>

                        </div>


                    </div>


                    <div class="col-lg-6 pull-right" *ngIf="showAddImage">
                        <!-- <div>Upload Pic. Comming Soon</div> -->
                        <div class="mb-3">
                            <label for="fileUpload" class="form-label">Select
                                Image</label>
                            <input type="file" class="form-control mb-3" id="uploadImage" (change)="handleOnChange($event)" />

                            <button type="button" (click)="addImageIntoMkms()" class="btn btn-primary">
                                Add Image
                            </button>

                        </div>
                        <div class="mb-3" >
                            <div *ngIf="mkm.mkmImages.length > 0; else noImages">
                                <div class="row">
                                    <div *ngFor="let img of mkm.mkmImages" class="col-3 mt-3 image-box">
                                        <a (click)="onDelete(img.id)" title="Delete Image" style="cursor: pointer">
                                            <i class="fa fa-remove"></i>
                                          </a>
                                        <img [src]="'data:image/jpeg;base64,' + img.imageFull" alt="">
                                    </div>
                                </div>
                            </div>
                            <ng-template #noImages>
                                <div>No Image Found</div>
                            </ng-template>
                        </div>
                    </div>

                </div>

                <div class="row">
                    <div class="col-lg-4 pull-right">
                        <div *ngIf="errors" class="alert alert-danger" role="alert" dir="ltr">
                            <strong>Oops!</strong> {{errors}}
                        </div>
                    </div>
                </div>
            </div>

        </form>
    </div>
</div>